module.exports = __webpack_public_path__ + "_config/_app/appConfiguration.json";